import { render, staticRenderFns } from "./IconEmbedVideo.vue?vue&type=template&id=16dd3fe8&"
import script from "./IconEmbedVideo.vue?vue&type=script&lang=js&"
export * from "./IconEmbedVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16dd3fe8')) {
      api.createRecord('16dd3fe8', component.options)
    } else {
      api.reload('16dd3fe8', component.options)
    }
    module.hot.accept("./IconEmbedVideo.vue?vue&type=template&id=16dd3fe8&", function () {
      api.rerender('16dd3fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconEmbedVideo.vue"
export default component.exports